import type { FaireProductEntity } from "../../entity_types/product";

export const p_zuq6b5a69e: FaireProductEntity = {
  token: "p_zuq6b5a69e",
  type: "product",
  name: "Dry Shampoo con Arrowroot",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/53f63a6f35bfc5328acddc7d6e8a3f8d5db334c55684b2601ea6ec1cfc5aeb9c.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  description: "Dry Shampoo con Arrowroot for wholesale.",
  tags: ["haircare"],
  caseSize: 4,
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
